<template>
    <div class="block pic-dialog" style="height:500px;" v-loading="loading"
         :element-loading-text="loading_text"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <!-- trigger="click" -->
        <iframe :src="iframe_src" width="800" height="500" hspace="0" vspace="0" frameborder="0" scrolling="no" id="iframeDom" ref="iframe" @load="sendMessage"></iframe>
       <div class="cover"></div>
    </div>
</template>

<script>
import pub from "../../service/public";
export default {
    name: "HeartIframe",
    props: {
        etc_url: {
            type: String
        },
        file_size: {
            type: Number
        }
    },
    data(){
        return{
            iframe_src:'', //localStorage.getItem('ETC_ROOT_READ')
            loading: false,
            loading_text: '拼命绘制中...',
            iframeWin: {},
            promptMess:'如有问题请联系销售',
            g_nZoom: 0.6,
            g_lead_font:12,
            g_time_font:18,
            g_disp_level:1,
            g_view_type:1,
            g_is_debug:true,
        }
    },
    methods:{
        listenIframe(event){
            const data = event.data;
            if(data.cmd == 'returnData'){
                this.backValue = {
                    file_status : data.params.fileStatus
                };
                this.$emit('backValueHandle', this.backValue);
                if(data.params.etc_load == true){
                  if(data.params.fileStatus == '403'){
                    this.loading_text = '文件无法访问，请联系销售';
                  }else{
                   this.loading = false;
                  }
                }
                if(data.params.fileStatus == 'file_error'){
                  this.loading_text = '由于文件内容过小导致绘制失败';
                }
                if(data.params.fileStatus == '404'){
                  this.loading_text = '文件不存在，请联系销售';
                }
            }
        },
        sendMessage(){
            this.loading = true;
            this.loading_text = '拼命绘制中...';
            let post = {
                promptMess:this.promptMess,
                fileUrl:this.etc_url,
                fileSize:this.file_size,
                action:'browser',
                viewZoom:this.g_nZoom,
                leadFontSize:this.g_lead_font,
                timeFontSize:this.g_time_font,
                viewType : this.g_view_type,
                dispLevel:this.g_disp_level,
                isDebug:this.g_is_debug
            };
            this.iframeWin = this.$refs.iframe.contentWindow;
            this.iframe_src = pub.ETC_ROOT + 'heartView';
            this.iframeWin.postMessage({cmd:'sendData',params:post}, '*');
        },
    },
    mounted () {
        this.$nextTick(() => {
          // 在外部 Vue 的 window 上添加 postMessage 的监听，并且绑定处理函数 handleMessage
          window.addEventListener('message', this.listenIframe)
        });
    },
    beforeDestroy(){
        window.addEventListener('message', this.listenIframe);
    },
}
</script>

<style scoped>
.pic-dialog {
    position: relative;
}

#iframeDom, .cover {
    width: 800px;
    height: 500px;
    position: absolute;
    overflow: hidden;
}

.cover {
    z-index: 2;
}

.pic-dialog .prev-btn {
    position: absolute;
    top: 240px;
    left: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 22px;
    line-height: 40px;
    z-index: 10;
    text-align: center;
    padding: 0;
}

.pic-dialog .next-btn {
    position: absolute;
    top: 240px;
    right: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 22px;
    line-height: 40px;
    z-index: 10;
    text-align: center;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/HeartIframe.vue